// client/menu-items/RedoMenuItem.ts
import "@adornis/chemistry/elements/components/x-icon.js";
import { redo } from "prosemirror-history";
var RedoMenuItem = {
  label: "Wiederherstellen",
  icon: "redo",
  run: async (view) => {
    const { state, dispatch } = view;
    redo(state, dispatch);
  },
  shouldVisualize: (view) => {
    return redo(view.state);
  }
};
export {
  RedoMenuItem
};
